<template>
    <transition name="fade-in-modal" mode="in-out" appear>
        <section class="modal modal__wrapper">
            <div class="modal__overlay" />
            <div class="modal__box">
                <Button class="modal__close" display="link" @click="$emit('close')" aria-label="Close Modal"><span class="icon" /></Button>
                <article class="modal__content">
                    <slot></slot>
                </article>
            </div>
        </section>
    </transition>
</template>

<script>
export default {
    created () {
        document.querySelector('body').style.overflow = 'hidden'
    },

    beforeDestroy () { document.querySelector('body').style.overflow = null }
}
</script>
